import CodeMirror from 'codemirror';
import 'codemirror/addon/display/placeholder';

export default class TextareaCodemirror {
	constructor({ elements }) {
		elements.forEach((el) => {
			const maxCharacters = el.dataset.codemirrorCounter;
			const { errorMessage, counterWithoutError } = el.dataset;

			// Attach CodeMirror
			const cmInstance = CodeMirror.fromTextArea(el, {
				lineNumbers: true,
				lineWrapping: true,
				autoRefresh: true,
				refresh: true,
			});

			let editorWrapper = el.nextElementSibling;
			while (editorWrapper && !editorWrapper.classList.contains('CodeMirror')) {
				editorWrapper = editorWrapper.nextElementSibling;
			}

			// Add character counter HTML after the textarea
			if (maxCharacters) {
				const counterHTML =
					!counterWithoutError && errorMessage
						? `<div class="counter-container">
                        <div class="textarea-counter">${maxCharacters}</div>
                        <div class="counter__error-message hide">${errorMessage}</div>
                     </div>`
						: `<div class="counter-container flex flex--self-end">
                        <div class="textarea-counter textarea-counter--alt">${maxCharacters}</div>
                     </div>`;

				editorWrapper.insertAdjacentHTML('afterend', counterHTML);
			}

			// Listen to changes in the CodeMirror instance
			cmInstance.on('change', (cm) => {
				const content = cm.getValue();
				const characters = content.length;

				// Update character counter
				let counterContainer = editorWrapper?.nextElementSibling;

				while (counterContainer && !counterContainer?.classList.contains('counter-container')) {
					counterContainer = counterContainer?.nextElementSibling;
				}

				const counter = counterContainer?.querySelector('.textarea-counter');
				if (counter) {
					counter.innerHTML = maxCharacters - characters;

					if (!counterWithoutError) {
						const errorMessageBox = counter?.nextElementSibling;

						if (characters > maxCharacters) {
							counter.classList.add('textarea-counter__error');
							errorMessageBox.classList.remove('hide');
						} else {
							counter.classList.remove('textarea-counter__error');
							errorMessageBox.classList.add('hide');
						}
					}
				}
			});
		});
	}
}
